import axios from 'axios';

export const customerService = {
    listCustomers,
	updateSupplierList,
	updateWfConfig,
	setParallelTextPdf,
	setIgnoreMatch100,
	setGaleradaComptaParaules,
	setTmx,
	listGlosaris,
	getGlossary,
	createGlossary,
	updateGlossary,
	uploadGlossary,
	uploadDocument,
	removeDocument,
	addWfConfig
};

function listCustomers() {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/customer/", {params: {}});
}

function updateSupplierList(idCustomer, idProduct, supplierCconfigs) {
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	let body = {supplierCconfigs};
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/customer/"+idCustomer+"/product/"+idProduct+"/updateSupplierConfigsOrder/", body, headers);
}

function updateWfConfig(idCustomer, idProduct, wfConfig) {
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	let body = wfConfig;
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/customer/"+idCustomer+"/product/"+idProduct+"/setConfig/", body, headers);
}

function addWfConfig(idCustomer, idProduct, idUser, idTranslator){
	let headers = {
		headers: {
		  'Content-Type': 'application/json;charset=UTF-8'
		},
		params: {
		}
	}
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/customer/"+idCustomer+"/product/"+idProduct+"/supplier/"+idTranslator+"/customeruser/"+idUser, "", headers);
}

function setTmx(idCustomer, idTmx){
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/customer/"+idCustomer+"/setTmx/"+idTmx, "", headers);
}

function setParallelTextPdf(idCustomer, parallelTextPdf){
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	let body = {'parallelTextPdf': parallelTextPdf};
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/customer/"+idCustomer+"/setParallelTextPdf", body, headers);
}

function setIgnoreMatch100(idCustomer, ignoreMatch100){
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	let body = {'ignoreMatch100': ignoreMatch100};
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/customer/"+idCustomer+"/setIgnoreMatch100", body, headers);
}

function setGaleradaComptaParaules(idCustomer, galeradaComptaParaules){
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	let body = {'galeradaComptaParaules': galeradaComptaParaules};
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/customer/"+idCustomer+"/galeradaComptaParaules", body, headers);
}

function listGlosaris(idCustomer){
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/glossary/lst/"+idCustomer, {params: {}});
}

function getGlossary(idGlossary){
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/glossary/"+idGlossary, {params: {}});
}

function createGlossary(glosaryDto){
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	let body = glosaryDto;
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/glossary/", body, headers);
}


function updateGlossary(glossaryId, glosaryDto){
	const headers = {
		headers: {
			'content-type': 'application/json; charset=utf-8'
		},
		params: {
		}
	}
	let body = glosaryDto;
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/glossary/"+glossaryId+"/", body, headers);
}
	
function uploadGlossary(glossaryId, glossary){
	console.log(glossary);
	const headers = {
		headers: {
			'content-type': 'multipart/form-data'
		},
		params: {
		}
	}
	const formData = new FormData();
	formData.append('glossary', new File([glossary], glossary.name, { type: glossary.type }));
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/glossary/"+glossaryId+"/content/", formData, headers);
}

function uploadDocument(custId, file){
	const headers = {
		headers: {
			'content-type': 'multipart/form-data'
		},
		params: {
		}
	}
	const formData = new FormData();
	formData.append('document', new File([file], file.name, { type: file.type }));
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/customer/"+custId+"/documentation", formData, headers);
}

function removeDocument(custId, docId){
	return axios.delete(process.env.REACT_APP_serverURL+"/documents-0.0.1/customer/"+custId+"/documentation/"+docId, {params: {}});
}